import { SupText } from "@repo/core-ui";
import React, { DetailedHTMLProps, HTMLAttributes, type JSX } from "react";
import { twMerge } from "tailwind-merge";

interface MenuItemProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  icon: JSX.Element;
  title: string;
  append?: JSX.Element;
}

export function MenuItem({ icon, title, className, append, ...props }: MenuItemProps) {
  return (
    <SupText as="div" variant="subtitle1" {...props} className={twMerge("flex h-14 items-center gap-2 pl-4 pr-1", className)}>
      {icon}
      {title}
      {append && <span className="ml-auto p-2">{append}</span>}
    </SupText>
  );
}
